import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import Button from 'react-bootstrap/Button';
import { useParams, useNavigate } from 'react-router-dom';
import toast from '../../service/toaster';
import './addPrediction.css';
import matchService from '../../service/matchService'
import predictionService from '../../service/predictionService'
import Loader from '../common/Loader';
import { redirectToLogin } from '../../service/authRedirect';


export default function MatchPrediction() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [match, setMatch] = useState(null);
  const [selections, setSelections] = useState({});
  const [submitted, setSubmitted] = useState(false); // New state for tracking submission
  const [summaryStats, setSummaryStats] = useState({});
  const isLive = match?.matchStatus === "Live";

  useEffect(() => {
    getItems();
  }, []);

  useEffect(() => {
    if (match) {
      // Check if userPrediction is present
      if (match?.userPrediction?.predictionType) {
        setSelections(match.userPrediction);
        setSubmitted(true); // pre-filled means treat as submitted
      } else {
        const initialSelections = {
          team1: { winner: true },
          team2: { winner: true }
        };

        match.sessions.forEach(session => {
          initialSelections.team1[session] = null;
          initialSelections.team2[session] = null;
        });

        setSelections(initialSelections);
      }
      if (!isLive) {
        setSubmitted(true); // lock inputs when match is not live
      }
    }
  }, [match, isLive])
  const getItems = async () => {
    try {
      let { data } = await predictionService.getPrediction(id);
      let data1 = await matchService.getMatch(id);

      console.log("prediction already", data1, "========",{...data?.[0]?.predictionStats});
      let finalData = { ...data1.data[0], userPrediction: data[0] }
      setMatch(finalData);
      setSummaryStats({...data?.[0]?.predictionStats})
    }
    catch (err) {
      console.log(err);
      toast.error("Matche can't be seen!!!");
      redirectToLogin(navigate);
    }
  }
  const getMatch = async () => {
    // deprecated: not used in the current flow
  }

  const handleSelection = (team, session, choice, selectedOdd) => {
    if (submitted || !isLive) return;
    setSelections(prevSelections => ({
      ...prevSelections,
      [team]: {
        ...prevSelections[team],
        [session]: { choice, selectedOdd }
      }
    }));
  };

  const handleWinnerSelection = (team) => {
    if (submitted || !isLive) return;
    const losingTeam = team === 'team1' ? 'team2' : 'team1';
    setSelections(prevSelections => ({
      ...prevSelections,
      [team]: { ...prevSelections[team], winner: true },
      [losingTeam]: { ...prevSelections[losingTeam], winner: false }
    }));
  };

  const handleSubmit = async () => {
    // Only submit if not already submitted and match is live
    if (submitted || !isLive) return;
    let data = await predictionService.doPrediction({ ...selections, match_id: id, "predictionType": "initial" });
    setSummaryStats(data.predictionResult||{})
    toast.success('Predictions submitted successfully!');
    setSubmitted(true); // Disable the button after submission
  };

  if (!match?.predictions?.team1 || !selections?.team1) {
    console.log(selections,  "selections");
    return <Loader fullscreen />;
  }
  else {
    console.log(match, "match");
  }

  const [teamOneName = "Team 1", teamTwoName = "Team 2"] = (match?.title?.split(" vs ") || []).map(t => t?.trim());

  return (
    <div className="prediction-view">
      <div className="prediction-hero">
        <div className="prediction-meta">
          <div className="meta-title">{match.title}</div>
          <div className="meta-sub">
            <span className="pill">{match.matchStatus || 'Upcoming'}</span>
            <span className="pill ghost">{match.published_at}</span>
            {match?.venue && <span className="pill ghost">{match.venue}</span>}
          </div>
          {match?.tags?.length ? (
            <div className="tag-row">
              {match.tags[0].split(',').map(tag => (
                <span key={tag} className="tag-pill">#{tag.trim()}</span>
              ))}
            </div>
          ) : null}
        </div>
        <div className="hero-flags">
          <div className="flag-block">
            <img src={match?.flagImages?.team1} alt={`${teamOneName} Flag`} />
            <div className="team-name">{teamOneName}</div>
          </div>
          <div className="vs-badge">VS</div>
          <div className="flag-block">
            <img src={match?.flagImages?.team2} alt={`${teamTwoName} Flag`} />
            <div className="team-name">{teamTwoName}</div>
          </div>
        </div>
        {match?.content && (
          <p className="meta-description">
            {match?.content?.length > 180 ? `${match?.content?.slice(0, 180)}...` : match?.content}
          </p>
        )}
      </div>

      <div className="card-container">
        <Card className="match-card">
          <div className="session-options-container">
            {/* Team 1 */}
            <div className="team-options">
              <h3 className="team-title">{teamOneName}</h3>
              {match?.sessions?.map((session) => (
                <div className="session" key={session}>
                  <p className="session-label">{session} Over Session Odds</p>

                  <div className="odds-row">
                    <Button
                      variant={selections?.team1?.[session]?.choice === 'no' ? 'danger' : 'outline-danger'}
                      className={`session-button ${selections?.team1?.[session]?.choice === 'no' ? 'no' : selections?.team1?.[session]?.choice === 'yes' ? 'yes' : 'default'}`}
                      onClick={() => handleSelection('team1', session, 'no', match?.predictions?.team1?.[session]?.[0])}
                      disabled={submitted || !isLive}
                    >
                      {match?.predictions?.team1?.[session]?.[0]}
                    </Button>
                    <Button
                      variant={selections?.team1?.[session]?.choice === 'yes' ? 'success' : 'outline-success'}
                      className={`session-button ${selections?.team1?.[session]?.choice === 'yes' ? 'yes' : selections?.team1?.[session]?.choice === 'no' ? 'no' : 'default'}`}
                      onClick={() => handleSelection('team1', session, 'yes', match?.predictions?.team1?.[session]?.[1])}
                      disabled={submitted || !isLive}
                    >
                      {match?.predictions?.team1?.[session]?.[1]}
                    </Button>
                  </div>
                  <div className="odds-hint">
                    {match?.predictions?.team1?.[session]?.[0]} - {match?.predictions?.team1?.[session]?.[1]}
                  </div>
                  {summaryStats && summaryStats?.sessions?.[session] && (
                    <div className="session-result">
                      <small>Yes: {summaryStats?.sessions?.[session]?.["team1"]?.yes || 0}%</small>
                      <br />
                      <small>No: {summaryStats?.sessions?.[session]?.["team1"]?.no || 0}%</small>
                    </div>
                  )}
                </div>
              ))}
              <div className={"winner-button-container"}>
                <Button
                  variant="success"
                  onClick={() => handleWinnerSelection('team1')}
                  className={selections?.team1?.winner ? "Winner" : "Loser"}
                  disabled={submitted || !isLive} // Disable if submitted or match not live
                >
                  {selections?.team1?.winner ? "Winner" : "Loser"}
                </Button>
                {summaryStats && (
                  <p className="winner-result">
                    Votes: {summaryStats?.winner?.["team1"] || "0%"}
                  </p>
                )}
              </div>
            </div>

            {/* VS Separator */}
            <div className="vs-separator">
              <span>VS</span>
            </div>

            {/* Team 2 */}
            <div className="team-options">
              <h3 className="team-title">{teamTwoName}</h3>

              {match?.sessions?.map((session) => (
                <div className="session" key={session}>
                  <p className="session-label">{session} Over Session Odds</p>

                  <div className="odds-row">
                    <Button
                      variant={selections?.team2?.[session]?.choice === 'no' ? 'danger' : 'outline-danger'}
                      className={`session-button ${selections?.team2?.[session]?.choice === 'no' ? 'no' : selections?.team2?.[session]?.choice === 'yes' ? 'yes' : 'default'}`}
                      onClick={() => handleSelection('team2', session, 'no', match?.predictions?.team1?.[session]?.[0])}
                      disabled={submitted || !isLive}
                    >
                      {match?.predictions?.team2?.[session]?.[0]}
                    </Button>
                    <Button
                      variant={selections?.team2?.[session]?.choice === 'yes' ? 'success' : 'outline-success'}
                      className={`session-button ${selections?.team2?.[session]?.choice === 'yes' ? 'yes' : selections?.team2?.[session]?.choice === 'no' ? 'no' : 'default'}`}
                      onClick={() => handleSelection('team2', session, 'yes', match?.predictions?.team1?.[session]?.[1])}
                      disabled={submitted || !isLive}
                    >
                      {match?.predictions?.team2?.[session]?.[1]}
                    </Button>
                  </div>
                  <div className="odds-hint">
                    {match?.predictions?.team2?.[session]?.[0]} - {match?.predictions?.team2?.[session]?.[1]}
                  </div>
                  {summaryStats && summaryStats?.sessions?.[session] && (
                    <div className="session-result">
                      <small>Yes: {summaryStats?.sessions?.[session]?.["team2"]?.yes || 0}%</small>
                      <br />
                      <small>No: {summaryStats?.sessions?.[session]?.["team2"]?.no || 0}%</small>
                    </div>
                  )}
                </div>
              ))}
              <div className={"winner-button-container"}>
                <Button
                  variant="success"
                  onClick={() => handleWinnerSelection('team2')}
                  className={selections?.team2.winner ? "Winner" : "Loser"}
                  disabled={submitted || !isLive} // Disable if submitted or match not live
                >
                  {selections?.team2.winner ? "Winner" : "Loser"}
                </Button>
                {summaryStats && (
                  <p className="winner-result">
                    Votes: {summaryStats?.winner?.["team2"] || "0%"}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Submit Button */}
          {!submitted &&
            <div className="submit-button-container">
              <Button
                variant="success"
                onClick={handleSubmit}
                disabled={submitted || !isLive} // Disable if submitted or match not live
              >
                Submit
              </Button>
            </div>
          }
        </Card>
      </div>
    </div>
  );
}
